import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import { Container } from 'reactstrap';
import { ScreensViewer } from './ScreensViewer';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import FieldsList from './FieldsList';

const Field = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Campos' links={breadcrumbLinks} />
					<FieldsList />
					{/* <ScreensViewer /> */}
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Field;
